const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.webp",
      name: "곰팡이 제거 및 재오염 방지",
      // txt2: '오래경험과 노하우 + 최신장비를 활용하여',
      // txt3: '보다 높은 확률로 탐지해냅니다.',
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=24",
    },
    {
      img: "/images/service2.webp",
      name: "태양광 크리닝",
    },
    {
      img: "/images/service3.webp",
      name: "빌딩 크리닝",
    },
    {
      img: "/images/service4.webp",
      name: "호텔 제품판매",
    },
    {
      img: "/images/service5.webp",
      name: "각종 산업시설의 복원크리닝",
    },
    {
      img: "/images/service6.webp",
      name: "중공업 및 건설회사 제품납품",
    },
    {
      img: "/images/service7.webp",
      name: "학교시설 크리닝",
    },
    {
      img: "/images/service8.webp",
      name: "드론 크리닝",
    },
  ];

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-14"
      >
        <h3 className="font-normal">서비스 목록</h3>
        <p className="text-primary my-5 lg:text-lg">- Service -</p>
        <p className=" lg:text-lg">
          카이노스&nbsp;Bio&nbsp;케미칼에서는
          아래와&nbsp;같은&nbsp;서비스를&nbsp;제공합니다
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-1 lg:grid-cols-4 gap-5 lg:gap-6">
        {serviceList.map((v, i) => (
          <div key={i} data-aos="fade-up" className="relative w-full h-full">
            <div className="relative w-full h-72 xl:h-80 overflow-hidden">
              <img
                className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                alt={`카이노스 바이오케미칼 ${v.name} 서비스`}
                src={v.img}
                width={414}
                height={506}
              />
            </div>
            <div className=" relative w-full h-fit text-center bg-primary text-white">
              <p
                className="py-2 xl:text-xl"
                dangerouslySetInnerHTML={{ __html: v.name }}
              ></p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
